import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import Pagos from './components/Pagos';
import { Http } from '../../../support';
import Result from '../../../facturotopia/Result';
import ShowPagoInfo from './components/ShowPagoInfo';
import Loading from '../../../facturotopia/loading/Loading';
import TipoComprobante from '../support/enum/TipoComprobante';
import PageHeader from '../../../support/page-header/PageHeader';
import FactorajeFinancieroTransform from '../support/factoraje/FactorajeFinancieroTransform';
import ProcessCfdiToJsonInputConversion from '../transformers/ProcessCfdiToJsonInputConversion';
import FactorajeFinancieroPagoCalculator from '../support/factoraje/FactorajeFinancieroPagoCalculator';

const FactorajeManagement = (props) => {
  const [data, setData] = useState({});
  const [input, setInput] = useState({});
  const [busy, setBusy] = useState(false);
  const [uuid] = useState(props.match.params.uuid);

  useEffect(() => {
    const request = async () => {
      try {
        setBusy(true);

        const params = {
          include: 'emisor,receptor,input,pagos,factoraje',
        };

        const response = await Http.get(`/api/comprobantes/${uuid}`, { params });

        let input = response.data.input;

        input.uuid = response.data.uuid;
        input.Emisor = response.data.emisor;
        input.Receptor = response.data.receptor;
        input.Factoraje = response.data.factoraje;

        const comprobante = TipoComprobante.pago();

        const data = ProcessCfdiToJsonInputConversion.make(input, comprobante);

        const FactorajeFinanciero = FactorajeFinancieroTransform.make(data).apply();

        const Pagos = FactorajeFinancieroPagoCalculator.make({
          data: {
            ...data,
            FactorajeFinanciero,
          },
        }).apply();

        setInput(input);

        setData({
          Pago: Pagos,
          FactorajeFinanciero,
          Factoraje: response.data.factoraje,
        });
      } catch (error) {
        window.ToastManager.show({
          variant: 'error',
          title: 'Error',
          message: error.data?.message || error.message || 'No fue posible leer tu factura. =(',
        });
      } finally {
        setBusy(false);
      }
    };

    request();
  }, [uuid]);

  const handleOnChange = (event) => {
    setInput({
      ...input,
      ...event,
    });
  };

  if (busy === true) {
    return <Loading />;
  }

  const isPaid = data.Factoraje?.ImporteSaldoInsoluto <= 0;

  return (
    <div className="comprobantes-create">
      <PageHeader
        to={`/app/comprobantes/${uuid}/info`}
        text="Mi factura"
      />

      {!!isPaid && (
        <Result
          className="mt-5"
          title="Pagado"
          subtitle="La factura ha sido pagada en su totalidad"
        />
      )}

      <div>
        {!busy && (
          <ShowPagoInfo
            uuid={uuid}
            data={input}
          />
        )}
      </div>

      {!busy && !isPaid && (
        <Row>
          <Col>
            <Pagos
              uuid={uuid}
              busy={busy}
              data={data}
              input={input}
              onChange={handleOnChange}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default FactorajeManagement;
